import {Controller} from "stimulus"
import axios from 'axios'

import {
    Power1,
    TweenLite,
} from "gsap/TweenLite"

import {
    TimelineLite,
} from "gsap/TimelineLite"

import {sendEvent as GaSendEvent} from "../utils/googleAnalytics";
import DOMUtils from "../utils/DOMUtils";

export default class extends Controller {

    static targets = [
        "ajaxContainer",
        "projects",
        "grid",
    ]

    initialize() {
        //this.$ajaxContainer.style.border = "2px solid red"
    }

    get maxPages() {
        return parseInt(this.data.get("maxPages"))
    }

    get maxItems() {
        return parseInt(this.data.get("maxItems"))
    }

    get index() {
        return parseInt(this.data.get("index"))
    }

    set index(value) {
        this.data.set("index", value)
    }

    get chunk() {
        return parseInt(this.data.get("chunk"))
    }

    loadMore(e) {

        e.preventDefault()

        this.index++
        this.element.classList.add("is-fetching")
        this.gridTarget.classList.add("no-animation")

        axios.get(urls.api_get_projects, {params: {chunk: this.chunk, index: this.index}})
            .then(response => {
                if (response.data.success) {
                    this.onSuccess(response)
                    GaSendEvent({
                        eventCategory: "Actions",
                        eventAction: "click",
                        eventLabel: "Load more projects - success"
                    })
                } else {
                    console.log("fail !", response)
                    GaSendEvent({
                        eventCategory: "Actions",
                        eventAction: "click",
                        eventLabel: "Load more projects - failed"
                    })
                }
            })
            .catch(error => {
                const response = error.response
                GaSendEvent({eventCategory: "Actions", eventAction: "click", eventLabel: "Load more projects - failed"})
                console.log("Fatal error", error)
            })

    }

    onSuccess(response) {

        const elements = response.data.posts
        const $container = this.$ajaxContainer
        const $innerContainer = $container.children[0]

        const tl = new TimelineLite({})

        tl.set($container, {
            height: `${$container.clientHeight}px`,
            onComplete: () => {
                elements.forEach(element => {
                    DOMUtils.insertAtTheEnd($innerContainer, element.itemHTML)
                    DOMUtils.insertAtEndOfBody(element.modalHTML)
                })
                const _tl = new TimelineLite()
                _tl.to($container, 0.4, {
                    ease: Power1.easeInOut,
                    height: `${$innerContainer.clientHeight}px`
                })
                _tl.set($container, {clearProps: "all"})
                _tl.set(this.element, {className: "-=is-fetching"})
                if (this.$projects.length === this.maxItems) {
                    _tl.set(this.element, {className: "+=has-nothing-to-fetch"})
                }
            }
        })

    }

    get $ajaxContainer() {
        return this.ajaxContainerTarget
    }

    get $projects() {
        return this.projectsTargets
    }

}